import { render, staticRenderFns } from "./SimuladorDetalhes.vue?vue&type=template&id=2c78da0c"
import script from "./SimuladorDetalhes.vue?vue&type=script&lang=js"
export * from "./SimuladorDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports